/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Picks = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_picks',
		from: 'top', //possible values: top, bottom, left, right
		item_class: 'item',
		self_closing: true
	},

	initialize: function(_element, options){
		this.setOptions(options);
		this._element = _element || document.getElements('.' + this.options.cls);

		if(typeOf(this._element) == 'elements'){
			this._element.each(function(_el){
				new Picks(_el, this.options);
			}.bind(this));
		}else if(this._element){
			this.build();
		}
	},

	build: function(){
		var opts = this.options;
		this._items = this._element.getElements('.' + opts.item_class) || this._element.getChildren();

		if(this._items.length == 0){
			this._items = [this._element];
		}

		this._items.each(function(_el){
			this.add_gallery_support(_el);
			this.add_cover_support(_el);
		}.bind(this));
	},

	add_cover_support: function(_el){
		var _cover = _el.getElement('.cover');

		if(!_cover) return;

		var opts = this.options;

		if(opts.from == 'top'){
			_cover.setStyles({
				'bottom': '100%',
				'left': 0
			});
		}else if(opts.from == 'bottom'){
			_cover.setStyles({
				'top': '100%',
				'left': 0
			});
		}else if(opts.from == 'left'){
			_cover.setStyles({
				'top': 0,
				'right': '100%'
			});
		}else{
			_cover.setStyles({
				'top': 0,
				'left': '100%'
			});
		}

		var _tracked_link = _el.getElement('.pub_container a.button');
		if (_tracked_link) {
			// track link for google and open link href in new tab
			_cover.removeEvents().addEvent('click', function(e){
				if(e.target.nodeName !== 'A') {
					_tracked_link.fireEvent('click');
					var href = _tracked_link.getAttribute('href');
					window.open(href, '_blank');
				}
			});
		}

		_cover.set('tween', {
			duration: 150,
			unit: '%',
			transition: Fx.Transitions.linear
		});

		_el.addEvents({
			'mouseenter': function(){
				this.show_cover(_cover);
			}.bind(this)
		});

		if(opts.self_closing){
			_el.addEvents({
				'mouseleave': function(){
					this.hide_cover(_cover);
				}.bind(this)
			});
		}else{
			_el.addEvents({
				'click:relay(".close")': function(){
					this.hide_cover(_cover);
				}.bind(this)
			});
		}
	},

	add_gallery_support: function(_el){
		if(!_el.getElement('.w_card')) return;

		new Card(_el.getElement('.w_card'), {
			autorun_duration: 3000,
			transition_duration: 800
		});
	},

	show_cover: function(_cover){
		var opts = this.options;

		if(opts.from == 'top'){
			_cover.tween('bottom', 0);
		}else if(opts.from == 'bottom'){
			_cover.tween('top', 0);
		}else if(opts.from == 'left'){
			_cover.tween('right', 0);
		}else{
			_cover.tween('left', 0);
		}
	},

	hide_cover: function(_cover){
		var opts = this.options;

		if(opts.from == 'top'){
			_cover.tween('bottom', 100);
		}else if(opts.from == 'bottom'){
			_cover.tween('top', 100);
		}else if(opts.from == 'left'){
			_cover.tween('right', 100);
		}else{
			_cover.tween('left', 100);
		}
	}
});
